/* * @Author: 刘枫 * @Date: 2020-10-27 10:35:49 * @Last Modified by: 李志远 *
@Last Modified time: 2021-10-Tu 02:31:46 * @tip: 1.通用积分 2.微信支付
3.支付宝支付 4.返购积分支付 5.奖金积分支付（扫码） 10.店长采购积分
11.奖金积分支付 12.网点收益积分支付 */
<template>
  <section>
    <div class="g_main" v-if="showPage">
      <div class="index_content">
        <div class="index_channel">
          <div class="mt10">
            <div class="index_channel_notice">
              <span class="title">应付金额：</span
              ><strong
                style="color: red; font-size: 18px; vertical-align: middle"
                >¥{{ totalAmount }}</strong
              >
            </div>
          </div>
          <div class="mt10">
            <div class="index_channel_notice">
              <span class="title">服务站：</span
              ><input
                type="text"
                v-model="payInfo.businessCentre"
                placeholder="请输入服务站（可选）"
                @input="inputchange"
                class="input_cuqmt mr10"
              /><span
                class="input_name"
                style="color: red"
                v-if="showBusinessCenter"
                >{{ userName }}</span
              >
            </div>
          </div>
          <div v-show="showPayForm">
            <!--  <div class='mt10'>
                      <div class="index_channel_notice"><span class='title'>支付密码：</span><input type="password"  v-model="payInfo.password" placeholder="请输入支付密码" class='input_cuqmt' ></div>
                  </div> -->
            <div class="mt10">
              <div class="index_channel_notice">
                <span class="title">验证码：</span
                ><input
                  type="text"
                  v-model="payInfo.code"
                  placeholder="请输入验证码"
                  class="input_cuqmt"
                />
                <button v-if="!showSec" class="getcode" @click="sendCode">
                  获取验证码
                </button>
                <button v-else class="seconds">已发送 ({{ seconds }}S)</button>
              </div>
            </div>
          </div>
          <div class="mt10">
            <div class="index_channel_notice"><span>付款方式</span></div>
            <div>
              <!-- 动态积分 -->
              <div
                class="pay_channel_wrapper pay_channel_wrapper_un"
                v-for="(item, index) in typeList"
                :key="index"
                v-show="item.paySwich != 0"
              >
                <div class="pay_channel float_clear">
                  <div
                    class="fl pay_channel_icon icons icons_channel_unselect pointer_g"
                  >
                    <div
                      class="self-radio"
                      @click="checkType(item.payType)"
                      :class="
                        checkedValue == item.payType ? 'selectActive' : ''
                      "
                    ></div>
                    <!-- <input
                      v-model="checkedValue"
                      type="radio"
                      name="payway"
                      :id="'way' + index"
                      :value="item.payType"
                      @click="checkType(item.payType)"
                    />
                    <label :for="'way' + index" class="pointer_g"></label> -->
                  </div>
                  <div class="float_clear">
                    <div class="pay_channel_type fl">
                      <span class="pointer_g">
                        <img :src="item.icon" class="pay_channel_logo" />
                        <strong>{{ item.payTypeName }}</strong>
                      </span>
                    </div>
                    <div
                      class="fl pay_channel_left"
                      v-show="[1, 10, 11, 12, 41, 21, 57].includes(item.payType)"
                    >
                      <div>
                        <span>可用积分：{{ _ponint(item.payType) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 立即支付 -->
            <div class="index_button_block">
              <div class="validate">
                <div class="base_button pointer_g" @click.stop.prevent="toPay">
                  立即支付
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <form method="post" name="form1" id="form1">
        <input type="hidden" name="out_trade_no" ref="zfbOutTradeNo" />
        <input type="hidden" name="orderList" ref="orderSns" />
        <input type="hidden" name="returnUrl" ref="returnUrl" />
        <input type="hidden" name="totalFee" :value="totalAmount" />
        <input type="hidden" name="token" ref="token" />
        <input type="hidden" name="tokenId" ref="tokenId" />
        <input type="hidden" name="businessCentre" ref="businessCentre" />
      </form>
    </div>
    <pay-list-modal
      v-if="isShowPayModal"
      :isShowPayModal.sync="isShowPayModal"
      :businessCentre="payInfo.businessCentre"
      :orderSns="orderList"
    ></pay-list-modal>
  </section>
</template>
<script>
import {
  checkOrderPay,
  doPay,
  checkBusinessCenter,
  getSettleCode,
} from "api/order";
import { getPaymentStatus, getMyPoint, getUserInfo } from "api/user";
import { getPayMent } from "api/cart";
import payListModal from "./payListModal";
export default {
  data() {
    return {
      orderId: this.$route.query.orderId,
      orderNo: this.$route.query.orderNo,
      showBusinessCenter: false,
      orderList: "",
      orderSns: "", //订单号
      totalAmount: 0, //应付金额
      shopping: 0, //通用积分
      shopowner: 0, //网店积分
      gold: 0, //奖金积分
      revenueAmount: 0, // 收益积分
      redEnvelopeAmount: 0, // 红包积分
      shoppingBonus: 0, // 购物奖励积分
      firstBuy: 0, //采购积分
      btnText: "立即支付",
      typeList: [], //类型列表
      orderInfo: {},
      seconds: 60, //倒计时
      showSec: false,
      timer: undefined, //定时器id
      showPayForm: false, //支付密码隐藏
      showPage: false, //数据加载完再显示界面
      checkedValue: 56, //选中值
      payInfo: {
        code: "",
        password: "",
        businessCentre: "",
      },
      settleServer: "", //卖家地址
      userName: "", //服务站名称
      delayTimer: null,
      isShowPayModal: false,
    };
  },
  components: {
    payListModal,
  },

  created() {
    this.getPayMent();
    this.getUserInfo();
    this.getMyPointData();
  },
  mounted() {},
  methods: {
    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.resCode === 1) {
          this.payInfo.businessCentre = res.data.businessCenter;
          if (this.payInfo.businessCentre) {
            this.checkBusinessCentre();
          }
        }
      });
    },
    inputchange() {
      let i = 0;
      if (this.delayTimer) {
        clearInterval(this.delayTimer);
      }
      this.delayTimer = setInterval(() => {
        i++;
        if (i == 2) {
          this.checkBusinessCentre();
          clearInterval(this.delayTimer);
        }
      }, 1000);
    },
    //获取支付方式
    getStatus() {
      getPaymentStatus({
        orderSn: this.orderNo,
        paymentSource: 0,
        toName: "",
      }).then((res) => {
        if (res.resCode === 1) {
          this.typeList = res.data;
        }
      });
    },
    //获取订单信息
    getPayMent() {
      getPayMent({
        orderNo: this.orderNo,
      }).then((res) => {
        if (res.resCode === 1) {
          this.orderInfo = res.data;
          this.orderList = res.data.orderList;
          this.totalAmount = res.data.orderSum;
          this.showBusinessCenter =
            res.data.showBusinessCenter == 0 ? false : true;
          this.showPage = true;
          this.getStatus();
        }
      });
    },
    // 获取用户优惠券额度
    getMyPointData() {
      // let postBody = this.$Rsa.encrypt(JSON.stringify({ loginName: getSession('userName') }))
      getMyPoint({}).then((res) => {
        this.shopping = res.data.shopMoney;
        this.shopowner = res.data.shopowner;
        this.gold = res.data.gold;
        this.firstBuy = res.data.firstBuy;
        this.revenueAmount = res.data.revenueAmount;
        this.redEnvelopeAmount = res.data.redEnvelopeAmount;
        this.shoppingBonus = res.data.shoppingBonus;
      });
    },
    //动态筛选积分返回值
    _ponint(index) {
      switch (index) {
        case 1:
          return this.shopping;
        case 10:
          return this.firstBuy;
        case 11:
          return this.gold;
        case 12:
          return this.shopowner;
        case 41:
          return this.revenueAmount;
        case 21:
          return this.redEnvelopeAmount;
        case 57:
          return this.shoppingBonus;
      }
    },
    //选择支付方式
    checkType(parm) {
      if (parm == 56) {
        this.showPayForm = false;
        this.isShowPayModal = true;
        this.btnText = "快捷支付";
        this.checkedValue = 56;
      }
      if (parm == 1) {
        this.showPayForm = true;
        this.btnText = "通用积分支付";
        this.checkedValue = 1;
      }
      if (parm == 2) {
        this.showPayForm = false;
        this.btnText = "微信支付";
        this.checkedValue = 2;
      }
      if (parm == 22) {
        this.showPayForm = false;
        this.btnText = "微信支付";
        this.checkedValue = 22;
      }
      if (parm == 3) {
        this.showPayForm = false;
        this.btnText = "支付宝支付";
        this.checkedValue = 3;
      }
      if (parm == 10) {
        this.showPayForm = true;
        this.btnText = "采购积分支付";
        this.checkedValue = 10;
      }
      if (parm == 11) {
        this.showPayForm = true;
        this.btnText = "奖金积分支付";
        this.checkedValue = 11;
      }
      if (parm == 12) {
        this.showPayForm = true;
        this.btnText = "网店积分支付";
        this.checkedValue = 12;
      }
      if (parm == 41) {
        this.showPayForm = true;
        this.btnText = "收益积分";
        this.checkedValue = 41;
      }
      if (parm == 21) {
        this.showPayForm = true;
        this.btnText = "红包积分";
        this.checkedValue = 21;
      }
      if (parm == 57) {
        this.showPayForm = true;
        this.btnText = "购物奖励积分";
        this.checkedValue = 57;
      }
    },
    //发送验证码
    sendCode() {
      //verificationCodeType："0"：支付验证码 "1"：找回密码验证码 "2"：注册验证码
      getSettleCode({
        type: 5,
      }).then((res) => {
        this.showSec = true;
        this.countDown();
        if (res.resCode === 1) {
          // this.$Message.success(res.resDesc)
        } else {
          // 返回不成功
          this.$Message.warning(res.resDesc);
        }
      });
    },
    //倒计时
    countDown() {
      const _this = this;
      this.timer = setInterval(function () {
        if (!_this.seconds) {
          clearInterval(_this.timer);
          _this.seconds = 60;
          _this.showSec = false;
          return;
        }
        _this.seconds -= 1;
      }, 1000);
    },
    //校验服务站
    checkBusinessCentre() {
      checkBusinessCenter({ loginName: this.payInfo.businessCentre }).then(
        (res) => {
          if (res.data == null) {
            this.$Message.warning("服务站不存在");
            this.payInfo.businessCentre = "";
            this.userName = "";
          } else {
            this.showBusinessCenter = true;
            this.userName = res.data.name;
          }
        }
      );
    },

    //立即支付
    toPay() {
      if (!this.checkedValue) {
        this.$Modal.warning({
          content: "请选择支付方式",
          onOk: () => {},
        });
        return;
      }
      if (this.checkedValue == 56) {
        this.showPayForm = false;
        this.isShowPayModal = true;
        return;
      }
      checkOrderPay({ orderNos: this.orderList }).then((res) => {
        if (res.resCode == 1) {
          if (this.checkedValue == 3) {
            this.aliPay();
          } else if (this.checkedValue == 2) {
            this.wxPay();
          } else if (this.checkedValue == 22) {
            this.hfwxPay();
          } else if (this.checkedValue == 56) {
            this.isShowPayModal = true;
          } else {
            this.IntegralPay();
          }
        } else {
          this.$Message.warning(res.resDesc);
        }
      });
    },
    //微信付款
    wxPay() {
      let businessCentre = this.payInfo.businessCentre;
      //v2版本商城接口支付
      const orderInfo = {
        businessCentre: businessCentre,
        orderSns: this.orderList,
        payCode: "",
        payType: 2,
        tradeType: "NATIVE",
        wxCode: "",
      };
      doPay(orderInfo).then((res) => {
        if (res.resCode === 1) {
          let payUrl = "";
          if (res.data.payWay === "ADAPAY_WXPAY_COMMON") {
            payUrl = JSON.parse(res.data.payData).expend.wx_h5_pay_url;
          } else {
            payUrl = res.data.payUrl;
          }
          this.$router.push({
            path: "/weixinPage",
            query: {
              payUrl: payUrl,
              orderId: this.orderId,
              orderList: this.orderList,
              totalAmount: this.totalAmount,
              payType: "order", //订单支付
            },
          });
        } else {
          // 返回不成功
          this.$Message.warning(res.resDesc);
        }
      });
    },
    //汇付微信付款
    hfwxPay() {
      this.$router.push({
        path: "/hfwxPage",
        query: {
          orderId: this.orderId,
          orderList: this.orderList,
          totalAmount: this.totalAmount,
          payType: "order", //订单支付
        },
      });
    },
    //支付宝付款
    aliPay() {
      let businessCentre = this.payInfo.businessCentre;
      //v2版本商城接口支付
      const orderInfo = {
        businessCentre: businessCentre,
        orderSns: this.orderList,
        payCode: "",
        payType: this.checkedValue,
        tradeType: "NATIVE",
      };
      doPay(orderInfo).then((res) => {
        console.log(res, "-----------------");
        if (res.resCode === 1) {
          if (res.data.payWay === "ADAPAY_ALIPAY_COMMON") {
            let payUrl = JSON.parse(res.data.payData).expend.qrcode_url;
            this.$router.push({
              path: "/aliPage",
              query: {
                payUrl: payUrl,
                orderId: this.orderId,
                orderList: this.orderList,
                totalAmount: this.totalAmount,
                payType: "order", //订单支付
              },
            });
          } else {
            $(document.body).html(res.data.payData);
          }
        } else {
          this.$Message.warning(res.resDesc);
        }
      });
    },
    //积分支付
    IntegralPay() {
      this.showPayForm = true;
      // if (!this.payInfo.password || this.payInfo.password.trim().length === 0) {
      //   this.$Message.warning('支付密码不能为空');
      //   return;
      // }
      if (!this.payInfo.code || this.payInfo.code.trim().length === 0) {
        this.$Message.warning("验证码不能为空");
        return;
      }
      const orderInfo = {
        businessCentre: this.payInfo.businessCentre,
        orderSns: this.orderList,
        payCode: this.payInfo.code,
        payType: this.checkedValue,
      };
      doPay(orderInfo).then((res) => {
        if (res.resCode === 1) {
          this.$Message.success(res.resDesc);
          this.$router.push({ path: "/member/order" });
        } else {
          // 返回不成功
          this.$Message.warning(res.resDesc);
        }
      });
    },
  },
};
</script>
<style lang="less" type="text/less" scoped>
.index_content {
  width: 978px;
  margin: 30px auto;
  background: #fff;
  .index_channel {
    background: #fff;
    padding: 12px 30px;
    box-shadow: 0 6px 32px rgba(0, 0, 0, 0.13);
    z-index: 1;
  }
  .index_channel_notice {
    .title {
      width: 80px;
      display: inline-block;
      line-height: 37px;
    }
    > span {
      font-weight: bold;
      font-size: 14px;
      color: #222;
    }
    > input {
      width: 240px;
      height: 35px;
      padding-left: 5px;
      border: 1px solid #ddd;
      font-size: 14px;
    }
  }
  .pay_channel_wrapper {
    padding: 10px 18px;
    box-sizing: border-box;
    background: #fff;
  }
  .pay_channel_wrapper_un {
    border-bottom: 1px solid #eee;
  }
  .pay_channel {
    line-height: 45px;
    padding-top: 8px;
    overflow: hidden;
    .pay_channel_icon {
      margin-right: 30px;
      -webkit-transform: translateY(4px);
      -ms-transform: translateY(4px);
      transform: translateY(4px);
    }
    .icons_channel_unselect {
      width: 24px;
      height: 22px;
      background-position: -2px 0;
      padding-top: 6px;
    }
    .pay_channel_type {
      width: 170px;
      .pay_channel_logo {
        width: 45px;
        font-size: 16px;
        color: #333;
        font-family: Microsoft Yahei;
        margin-right: 5px;
        vertical-align: top;
      }
      .pay_channel_name {
        font-size: 16px;
        color: #333;
        font-family: Microsoft Yahei;
        margin-right: 5px;
        vertical-align: top;
      }
      strong {
        font-size: 14px;
      }
    }
  }

  .self-radio {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 1px solid #999;
  }

  .selectActive {
    background-color: #fe6d32;
    border: 1px solid #fe6d32;
    position: relative;
  }

  .selectActive::after {
    position: absolute;
    content: "";
    width: 5px;
    height: 10px;
    top: 4px;
    left: 8px;
    border: 2px solid #fff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
  }

  input[type="radio"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }

  label {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #999;
  }
  input:checked + label {
    background-color: #fe6d32;
    border: 1px solid #fe6d32;
  }
  input:checked + label::after {
    position: absolute;
    content: "";
    width: 5px;
    height: 10px;
    top: 4px;
    left: 8px;
    border: 2px solid #fff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
  }
}
.index_button_block {
  margin-left: 70px;
  margin-top: 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.pointer_g {
  cursor: pointer;
}
.base_button {
  display: inline-block;
  width: 222px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #e31613;
  border: 1px solid #e31613;
  border-radius: 2px;
  font-family: Microsoft Yahei;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.getcode {
  position: relative;
  z-index: 2;
  width: 126px;
  height: 35px;
  margin-left: 10px;
  text-align: center;
  background-color: #57565f;
  line-height: 36px;
  color: #fff;
  cursor: default;
  border-radius: 2px;
  font-size: 14px;
  border: 1px solid #dedede;
  background-color: #f3f3f3;
  cursor: pointer;
  color: #666;
}
.seconds {
  position: relative;
  z-index: 2;
  width: 126px;
  height: 37px;
  margin-left: 10px;
  text-align: center;
  background-color: #57565f;
  line-height: 36px;
  color: #fff;
  cursor: default;
  border-radius: 2px;
  font-size: 14px;
  border: 0;
}
.mr10 {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// toPay.vue?36f3f5e0